
import get from 'lodash/fp/get.js'
import { computed } from '@nuxtjs/composition-api';

export default {
  props: {
    variant: {
      type: String,
      default: '',
      required: true
    }
  },
  setup (props) {
    const variantAttrs = computed(() => {
      const variants = {
        primary: {
          rounded: true,
          large: true,
          color: 'primary',
          class: 'secondary--text font-weight-bold text-none tlm-btn'
        },
        secondary: {
          rounded: true,
          large: true,
          color: 'secondary',
          class: 'tertiary--text font-weight-bold text-none tlm-btn'
        },
        tertiary: {
          rounded: true,
          large: true,
          color: 'tertiary',
          class: 'secondary--text font-weight-bold text-none tlm-btn'
        },
        info: {
          rounded: true,
          large: true,
          color: 'info',
          class: 'primary--text font-weight-bold text-none tlm-btn'
        },
        gray: {
          rounded: true,
          large: true,
          color: 'gray lighten-2',
          class: 'font-weight-bold text-none tlm-btn'
        }
      }

      return { ...get(props.variant)(variants) }
    })
    return {
      variantAttrs
    }
  }
}
